// extracted by mini-css-extract-plugin
export default {"base":"Remove_base__QHkmI","base__left":"Remove_base__left__ZclTL","base__right":"Remove_base__right__noN1R"};